import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const NotebookSchema = withDefaults({
  type: 'notebook',
  fields: [
    { kind: 'attribute', name: 'companyId' },
    { kind: 'attribute', name: 'name' },
    { kind: 'attribute', name: 'description' },
    { kind: 'attribute', name: 'documentsCount' },
    { kind: 'attribute', name: 'readyDocumentsCount' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
  ],
});

export default NotebookSchema;
